import { atom } from "jotai"
import { ComponentProps, FC } from "react"
import { store } from "@/store/store"

export const dialogsAtom = atom<Array<[FC<any>, ComponentProps<any>]>>([])

export const pushDialog = <C extends FC<P>, P = ComponentProps<C>>(component: C, props?: P) => {
	const currentDialogs = store.get(dialogsAtom)
	store.set(dialogsAtom, [...currentDialogs, [component, props]])
}

export const replaceDialog = <C extends FC<P>, P = ComponentProps<C>>(component: C, props?: P) => {
	const currentDialogs = store.get(dialogsAtom).slice(0, -1)
	store.set(dialogsAtom, [...currentDialogs, [component, props]])
}

export const popDialog = (count: number = 1) => {
	if (count <= 0) {
		return
	}
	const currentDialogs = store.get(dialogsAtom)
	if (currentDialogs.length <= count) {
		store.set(dialogsAtom, [])
		return
	}
	// Remove the last `count` dialogs
	store.set(dialogsAtom, currentDialogs.slice(0, -count))
}

export const resetDialogs = () => {
	store.set(dialogsAtom, [])
}

export const canPopDialog = () => {
	return store.get(dialogsAtom).length > 1
}
